import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { loadPublishersData } from './actions'

function mapStateToProps(state, hocProps) {
    const module = hocProps?.module
    const id = hocProps?.id
    const block = hocProps?.block
    const tenderId = hocProps?.tenderId
    const customDataPath = [
        'ui',
        'workspace',
        module,
        id,
        'blocks',
        block,
        'customData',
        'wonTenders',
        'details',
        tenderId,
        'publishers',
    ]

    return {
        data: state.getIn([...customDataPath, 'data'], []),
        isLoading: state.getIn([...customDataPath, 'isLoading'], false),
        loaded: state.getIn([...customDataPath, 'loaded'], false),
        failed: state.getIn([...customDataPath, 'failed'], false),
        dataLocale: state.getIn([...customDataPath, 'dataLocale'], null),
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            loadPublishersData,
        },
        dispatch
    )
}

export default function (InnerComponent) {
    @connect(mapStateToProps, mapDispatchToProps)
    class HocConnect extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }
    return HocConnect
}
